import type {CreateLeadFormPayload} from "./create-lead.schema";
import type {CreateLeadRequest} from "@project/sdk/sales";

export const createLeadMapper = {
  toSdk: (payload: CreateLeadFormPayload): CreateLeadRequest => ({
    company: {
      companyName: payload.companyName,
      partyProfile: {
        address: {address: payload.address},
        country: payload.country,
        phone: {
          regionCode: payload.phonePrefix,
          nationalNumber: payload.phoneNumber,
        },
        websiteUrl: payload.websiteUrl,
      },
    },
    environments: payload.type,
    logoUrl: payload.logoUrl,
  }),
};
